import { render, staticRenderFns } from "./AuthLogo.vue?vue&type=template&id=86a49b8a&scoped=true&"
import script from "./AuthLogo.vue?vue&type=script&lang=js&"
export * from "./AuthLogo.vue?vue&type=script&lang=js&"
import style0 from "./AuthLogo.vue?vue&type=style&index=0&id=86a49b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a49b8a",
  null
  
)

export default component.exports